import { toPascalCaseWithSpaces } from '../../utils/utils'
import ElitePowerRankLeaderboard from '../elite/elite-sections/ElitePowerRankLeaderboard'
import PeersSheet from './PeersSheet'

interface Fund {
  isin: string
  fundName: string
  powerRank: number
}

export const LeaderboardSheetWrapper = ({
  fundCategory,
  closeBottomSheet,
  isSheetOpen,
  peerData,
  getRank,
  alternateISIN
}: {
  fundCategory: string
  closeBottomSheet: () => void
  isSheetOpen: boolean
  peerData: Fund[]
  getRank: () => number
  alternateISIN: string
}) => {
  return (
    <PeersSheet
      header={
        <div className='flex flex-col text-left pb-2'>
          <div className={`text-black text-[14px] font-[500] pb-1`}>
            <span className='text-[#CC7A29]'> Power Rank </span> in {toPascalCaseWithSpaces(fundCategory)}
          </div>
        </div>
      }
      isOpen={isSheetOpen}
      onClose={closeBottomSheet}
    >
      <div className='w-full pl-5 pr-5 pb-1'>
        {peerData?.length > 0 ? (
          <ElitePowerRankLeaderboard
            data={peerData}
            powerRank={getRank()}
            isinToBeHighlighted={alternateISIN}
            isRenderAllRows={true}
          />
        ) : (
          <ElitePowerRankLeaderboard
            data={Array(5)
              .fill(0)
              ?.map((_datum, idx) => {
                return {
                  powerRank: idx + 1,
                  fundName: idx === 2 ? 'Peer List Unavailable' : '-',
                  isin: idx === 2 ? alternateISIN : ''
                }
              })}
            powerRank={3}
            isinToBeHighlighted={alternateISIN}
            isRenderAllRows={false}
            isError={true}
          />
        )}
      </div>
    </PeersSheet>
  )
}
